/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import WebpackerReact from 'webpacker-react';
import ReactDOM from 'react-dom';

import 'flatpickr/dist/flatpickr.css';

import Changelog from '../apps/changelog/changelog';
import { setLocale } from '../apps/i18n';

WebpackerReact.setup({ Changelog });

// Initialize locale from HTML lang attribute
setLocale();

window.unmountComponent = function (domnode) {
  try {
    ReactDOM.unmountComponentAtNode(domnode);
  } catch (e) {
    console.log(e);
  }
};

window.openModal = function (html, dialog = '#main-dialog') {
  setLocale();

  var $dialog = $(dialog);
  $dialog.html(
    html
  ).modal({ backdrop: 'static' }).modal('show');

  if (window.WebpackerReact) {
    WebpackerReact.mountComponents();
  }
  $dialog.one('hidden.bs.modal', function () {
    var mountedComponent = $dialog.find('[data-react-class]')[0];
    if (mountedComponent) {
      window.unmountComponent(mountedComponent);
    }
    $dialog.html('');
  });
  $dialog.one('shown.bs.modal', function () {
    $(dialog).trigger('focus');
  });

  $('[data-toggle="tooltip"]', $dialog).tooltip();

  $('.loading-btn').on('click', function () {
    $(this).button('loading');
  });

  $('select.select2:not(.select2-offscreen)').select2({
    theme: 'bootstrap',
    selectOnClose: false
  });

  return $dialog;
};

window.closeModals = function () {
  $('.modal').modal('hide');
};
